"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const classnames_1 = __importDefault(require("classnames"));
const popover_button_style_1 = __importDefault(require("./popover.button.style"));
const avatar_bg_svg_1 = __importDefault(require("../avatar/avatar.bg.svg"));
class PopoverButton extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, buttonRef: ref, small, expanded, onClick, avatarButton, 
            // eslint-disable-next-line
            avatarSize, avatarSrc, loading } = this.props;
            const rootProps = {
                type: 'button',
                onClick,
                ref,
                'aria-busy': loading,
                'aria-expanded': !loading && expanded,
                'aria-haspopup': true,
                disabled: loading,
                className: classnames_1.default({
                    [classes.root]: true,
                    [classes.rootTricolon]: !avatarButton,
                    [classes.rootTricolonSmall]: !avatarButton && small,
                    [classes.rootAvatar]: avatarButton
                })
            };
            return (jsx_runtime_1.jsx("button", Object.assign({}, rootProps, { children: jsx_runtime_1.jsx("span", { children: !loading && avatarButton ? (jsx_runtime_1.jsx("img", { src: avatarSrc || avatar_bg_svg_1.default, alt: "User avatar" }, void 0)) : (jsx_runtime_1.jsx("i", {}, void 0)) }, void 0) }), void 0));
        };
    }
}
exports.PopoverButton = PopoverButton;
PopoverButton.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    buttonRef: prop_types_1.default.func.isRequired,
    small: prop_types_1.default.bool.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    expanded: prop_types_1.default.bool.isRequired,
    avatarButton: prop_types_1.default.bool.isRequired,
    avatarSize: prop_types_1.default.number,
    avatarSrc: prop_types_1.default.string,
    loading: prop_types_1.default.bool.isRequired
};
PopoverButton.defaultProps = {
    avatarSrc: null,
    avatarSize: null
};
exports.default = react_jss_1.default(popover_button_style_1.default)(PopoverButton);
//# sourceMappingURL=popover.button.js.map